// extracted by mini-css-extract-plugin
module.exports = {"Start":"Start_Start__6W8v5","Buttons":"Start_Buttons__2sEk7","ExploreButton":"Start_ExploreButton__2cyk2"};